import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorComponent, RadioButtonComponent } from '@progress/kendo-angular-inputs';
import { ControlNamePipe } from 'src/app/pipes/control-name.pipe';
import { LabelComponent } from '@progress/kendo-angular-label';
import { TranslatePipe } from '@ngx-translate/core';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { TestDataService } from 'src/app/services/testData.service';
import { FormService } from 'src/app/services/form.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-terms-and-conditions',
    imports: [
        RadioButtonComponent,
        ReactiveFormsModule,
        ErrorComponent,
        LabelComponent,
        ControlNamePipe,
        TranslatePipe,
        SpacerComponent,
    ],
    templateUrl: './terms-and-conditions.component.html',
    styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  private testDataService = inject(TestDataService);
  private testDataSubscription: Subscription;

  private formService = inject(FormService);

  @Input({required: true}) formId: string;

  formGroup: FormGroup;

  ngOnInit() {
    const privacy = this.formService.form().privacy;
    const marketing = this.formService.form().marketing;

    this.formGroup = new FormGroup({
      privacy: new FormControl<any>(privacy?.toString(), Validators.requiredTrue),
      marketing: new FormControl<any>(marketing?.toString(), Validators.required),
    });

    this.formGroup.valueChanges.subscribe((values) => {
      const privacy: any = values?.privacy || false;
      if (privacy?.toString() === 'true') this.formGroup.get('privacy')?.setErrors(null);
      this.buildAGB();
    });

    this.initTestDataObserver();
  }

  private initTestDataObserver() {
    this.testDataSubscription = this.testDataService.fillDataObserver.subscribe(() => {
      if (document.getElementById(this.formId)) {
        this.formGroup.get('privacy')?.setValue('true');
        this.formGroup.get('marketing')?.setValue('false');
        this.formGroup.markAllAsTouched();
      }
    });
  }

  private buildAGB() {
    const values: any = this.formGroup.getRawValue();
    this.formService.update({
      ...this.formService.form(),
      privacy: values.privacy === 'true' ? true : (values.privacy === 'false' ? false : undefined),
      marketing: values.marketing === 'true' ? true : (values.marketing === 'false' ? false : undefined)
    });
  }

  submit() {
    this.formGroup.markAllAsTouched();
    this.buildAGB();
  }

  ngOnDestroy() {
    this.testDataSubscription?.unsubscribe();
  }

}
